import { withTheme } from "@mui/styles";
import styled from "styled-components";
import { Box } from "@mui/material";

export const StyledArticlesList = withTheme(styled(Box)`
    && {
    }
`);
